export const HasIcon = ({ className }) => {
  return (
    <svg className={className} width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icons / bx-hash">
    <path id="Vector" d="M10.6787 3.04297L10.1547 5.83297H6.844L7.32133 3.28964L6.012 3.04297L5.488 5.83297H2.66667V7.1663H5.238L4.73733 9.83297H2V11.1663H4.48733L4.01133 13.703L5.32133 13.949L5.844 11.1663H9.15467L8.67867 13.703L9.98867 13.949L10.5107 11.1663H13.3333V9.83297H10.7607L11.2613 7.1663H14V5.83297H11.5113L11.9887 3.28964L10.6787 3.04297ZM9.404 9.83297H6.094L6.59467 7.1663H9.90533L9.404 9.83297Z" fill="currentColor"/>
    </g>
    </svg>
  )
}